<div class="ship-service-estimate">
    <div class="details">
        <div class="title">
            <h4 class="service-name">{{ estimator?.ServiceCodeDescription }}</h4>
            <div class="transit-days"> {{'costEstimator.transitDays'|translate : { TransitDays: estimator?.BusinessDaysInTransit} }}</div>
        </div>
        <div class="costs">
            <!-- <div *ngIf="(!isInsuredAmountExceeded && estimator?.TotalCharges != 0)">
                <span class="base-fee">{{'costEstimator.fees.baseFee'|translate}} ({{ estimator?.BaseRate | currency: 'USD' : 'symbol' }}) +</span>
                <span class="accessorial-cost">{{'costEstimator.fees.accessorialCost'|translate}}({{ estimator?.AccessorialsCost | currency: 'USD' : 'symbol' }})</span>
                <span class="accessorial-fee">{{'costEstimator.fees.fuelCharge'|translate}} 
                    ({{ estimator?.CarrierCode == 'Ups' ? estimator?.EstimatorDetail[0].AccessorialFee :
                     estimator?.EstimatorDetail[2].AccessorialFee| currency: 'USD' : 'symbol' }})</span>
                <span class="shipping-cost">{{'costEstimator.fees.shippingCost'|translate}} ({{ estimator?.ShippingCost ? estimator.ShippingCost : 0 | currency: 'USD' : 'symbol' }})</span>
            </div> -->


            <div *ngIf="(!isInsuredAmountExceeded && estimator?.TotalCharges != 0)">
                <span class="base-fee">{{'costEstimator.fees.baseFee'|translate}}{{' Plus '}}</span>
                <span class="accessorial-cost">{{'costEstimator.fees.accessorialCost'|translate}}</span>

                <div *ngIf="estimator?.CarrierCode == 'Ups'">
                    <span class="accessorial-fee">{{'costEstimator.fees.fuelCharge'|translate}} </span>
                </div>
                <div *ngIf="estimator?.CarrierCode == 'Fedex'">                 
                        <div *ngIf="estimator?.EstimatorDetail[0]?.AccessorialDescription == 'Fuel'">
                            <span class="accessorial-fee">{{'costEstimator.fees.fuelCharge'|translate}} </span>    
                        </div>
                        <div *ngIf="estimator?.EstimatorDetail[1]?.AccessorialDescription  == 'Fuel'">
                            <span class="accessorial-fee">{{'costEstimator.fees.fuelCharge'|translate}} </span>    
                        </div>
                        <div *ngIf="estimator?.EstimatorDetail[2]?.AccessorialDescription  == 'Fuel'">
                            <span class="accessorial-fee">{{'costEstimator.fees.fuelCharge'|translate}} </span>    
                        </div>          
                </div>
              
                <span class="shipping-cost">{{'costEstimator.fees.shippingCost'|translate}} </span>
            </div> 
            
            <div *ngIf="isInsuredAmountExceeded || estimator?.TotalCharges == 0">
                <span class="base-fee">{{'N/A'}}</span>
            </div>

        </div>
    </div>
    <div class="summary">
        <div class="total" *ngIf="!isInsuredAmountExceeded" >            
            {{ estimator?.TotalCharges == 0 ? 'N/A' : estimator?.TotalCharges | currency: 'USD' : 'symbol' }}
        </div>
        <div class="total" *ngIf="isInsuredAmountExceeded" >
            N/A
            </div>  
        <div class="actions" >
            <button mat-raised-button type="button" *ngIf="!isInsuredAmountExceeded" class="action" (click)="shipNow($event)">{{'costEstimator.ShipNow'|translate}}</button>
        </div>
    </div>
</div>
